import LightOrDark from '../composables/LightOrDark'

export default {
  install(Vue) {
    const d = document.body
    let theme

    Vue.directive('page-theme', {
      mounted: function (el, binding) {
        //console.log(el)
        if (binding.value.bg) {
          theme = LightOrDark(binding.value.bg) == 'light' ? 'LightTheme' : 'DarkTheme'
          d.style.setProperty('--themePageBackground', binding.value.bg)
          d.style.setProperty('--themeGradientBackground', binding.value.bg + '80')
        } else {
          theme = 'LightTheme'
          d.style.setProperty('--themePageBackground', '#fff')
          d.style.setProperty('--themeGradientBackground', '#ffffff80')
        }

        d.classList.add(theme)
        
        d.style.setProperty('--themeTextColor', binding.value.text)
      },
      unmounted: function () {
        //console.log(el)
        d.classList.remove(theme)
        d.style.removeProperty('--themePageBackground')
        d.style.removeProperty('--themeGradientBackground')
        d.style.removeProperty('--themeTextColor')
      }
    })
  }
}
